import config from 'config';

export function buildPoolCookie(poolCookieValue) {
  const domain = config.BPCookieDomain ? `domain=${config.BPCookieDomain};` : '';
  const expirationTime = new Date();
  expirationTime.setHours(expirationTime.getHours() + 3);
  const expires = `expires=${expirationTime.toUTCString()};`;
  return `BP=${poolCookieValue}; Path=/; Secure; HttpOnly; ${domain} ${expires}`;
}
